import LinearProgress from '@/global/components/LinearProgress'
import { Link } from '@/global/components/Link'
import Grid from '@/global/components/ui/Grid'
import { cn } from '@/lib/utils'
import { REMOVE_MASK_CPF, cpfMask } from '@acme/common'
import { Button } from 'global/components/Button'
import { FormField, FormFieldCheckbox } from 'global/components/Form'
import { useAuth } from 'hooks/useAuth'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { rememberMeStore } from './store'

interface IProps {
    minimal?: boolean
}

export function LoginForm({ minimal = false }: IProps) {
    const { watch, setValue } = useFormContext()
    const { loading } = useAuth()
    const { forgetMe, rememberMe, emailAvaliacao } = rememberMeStore()

    const checked = watch('rememberMe')
    const email = watch('email')

    useEffect(() => {
        if (!checked && rememberMe) {
            setValue('rememberMe', true)
        }

        if (emailAvaliacao && !email) {
            setValue('email', emailAvaliacao)
        } else if (rememberMe?.email && !email) {
            setValue('email', rememberMe.email)
        }
    }, [])

    useEffect(() => {
        const cpf = String(email).replace(REMOVE_MASK_CPF, '')
        if (email && cpf.length === 11 && !isNaN(Number(cpf)))
            setValue('email', cpfMask(Number(cpf)))
    }, [email])

    if (minimal)
        return (
            <Grid container>
                <Grid item xs={12} sm={6}>
                    <FormField name="email" label="E-mail ou CPF" />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        name="password"
                        label="Senha"
                        type="password"
                        autoComplete="current-password"
                    />
                </Grid>
            </Grid>
        )

    return (
        <div className="w-full">
            <LinearProgress
                className={cn({
                    hidden: !loading,
                })}
            />
            <div>
                <FormField name="email" label="E-mail ou CPF" />
                <FormField
                    name="password"
                    label="Senha"
                    type="password"
                    autoComplete="current-password"
                />
                <div className="flex items-center justify-between gap-8">
                    <FormFieldCheckbox
                        name="rememberMe"
                        label="Lembre-se de mim"
                        onChange={marcado => {
                            if (!marcado) forgetMe()
                        }}
                    />
                    <Link href="/recuperar-senha">Esqueceu a senha?</Link>
                </div>
            </div>
            <div className="flex flex-col gap-4 mt-4">
                <Button type="submit" fullWidth>
                    Entrar
                </Button>
                <Button href="/avaliacao" fullWidth color="warning">
                    Teste grátis
                </Button>
            </div>
        </div>
    )
}
